import styled from '@emotion/styled';
import theme from '../../theme';
import { basicLinkStyles, hoverLinkStyles } from '../Link/Link.styles';

// eslint-disable-next-line import/prefer-default-export
export const ButtonElement = styled.button({
  padding: 0,
  margin: 0,
  fontFamily: theme.font.family,
  background: 'none transparent',
  borderRadius: 0,
  border: 'none',
  cursor: 'pointer',

  '&.solid, &.outline': {
    padding: '.5rem 1rem',
    fontWeight: 700,
    fontSize: '1.125rem',
    textTransform: 'uppercase',
    border: `solid 3px ${theme.colors.darkBlue}`,

    [`@media ${theme.breakpoints.above.small}`]: {
      fontSize: '1.25rem',
      lineHeight: '1.6875rem',
    },

    span: {
      textAlign: 'center',
      minWidth: '9.25rem',
    },
  },

  '&.solid': {
    color: theme.colors.light,
    backgroundColor: theme.colors.darkBlue,
  },

  '&.outline': {
    color: theme.colors.darkBlue,
    backgroundColor: theme.colors.light,
  },

  '&.link': {
    ...basicLinkStyles,

    fontWeight: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',

    color: theme.colors.darkBlue,
    ':hover': hoverLinkStyles,
  },

});
